import { render, staticRenderFns } from "./ListDoctorAdmin.vue?vue&type=template&id=056edb3d&scoped=true&"
import script from "./ListDoctorAdmin.vue?vue&type=script&lang=ts&"
export * from "./ListDoctorAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./ListDoctorAdmin.vue?vue&type=style&index=0&id=056edb3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056edb3d",
  null
  
)

export default component.exports